import {Timezones} from '@/utils/constants/timeZones'
import {format} from 'date-fns'
import {DateTime} from 'luxon'

const getJsDateFromObject = zoneDateTime => {
  const dateTime = zoneDateTime.toObject()

  if (!dateTime?.year || !dateTime?.month) return

  return new Date(dateTime.year, dateTime.month - 1, dateTime.day, dateTime.hour, dateTime.minute, dateTime.second)
}

/**
 * This function is used to format a UTC iso string to as human friendly text for specific country's timezone.
 */
export const formatPeriodDate = (date, country, formatStr = 'PPP') => {
  if (!date || !country) return ''

  const tz = Timezones[country]

  const zoneDateTime = DateTime.fromISO(date, {zone: Timezones.UTC}).setZone(tz)
  const dateAsObj = getJsDateFromObject(zoneDateTime)
  return dateAsObj ? format(dateAsObj, formatStr) : undefined
}

/*
 * This function is used to convert a UTC iso string to a local date object from a specific timezone.
 */
export const convertUtcStringToJsDate = ({date, timezone}) => {
  if (!date || !timezone) return

  const zoneDateTime = DateTime.fromISO(date, {zone: Timezones.UTC}).setZone(timezone)
  return getJsDateFromObject(zoneDateTime)
}

/**
 * This function is used to convert a local JS Date object to a Luxon DateTime object in a specific timezone.
 */
export const convertJsDateToDateTimeByTimezone = ({date, timezone}) => {
  if (!date) return

  const dateLocale = date.toLocaleDateString('en-US')
  return DateTime.fromFormat(dateLocale, 'M/d/yyyy', {zone: timezone})
}

export const getFormattedDateFromString = (dateString) => {
  if (!dateString) return '';
  
  try {
    const [year, month, day] = dateString.split('-')
    if (!year || !month || !day) return dateString
    
    const date = new Date(`${year}-${month}-${day}`)
    if (isNaN(date.getTime())) return dateString
    
    return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`
  } catch (error) {
    console.error('Error formatting date:', error)
    return dateString
  }
}
